import { render, staticRenderFns } from "./topcvp.vue?vue&type=template&id=9afdbdd8&scoped=true"
import script from "./topcvp.vue?vue&type=script&lang=js"
export * from "./topcvp.vue?vue&type=script&lang=js"
import style0 from "./topcvp.vue?vue&type=style&index=0&id=9afdbdd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afdbdd8",
  null
  
)

export default component.exports